import PropTypes from 'prop-types'
import React from 'react'

export function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`home-tabpanel-${index}`}
			aria-labelledby={`home-tab-${index}`}
			{...other}
		>
			{value === index && <div style={{ padding: 10 }}>{children}</div>}
		</div>
	)
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
}

export function a11yProps(index) {
	return {
		id: `home-tab-${index}`,
		'aria-controls': `home-tabpanel-${index}`
	}
}
